import { gql } from '@apollo/client'

const SIDE_FIELDS = `
    adSetId
    adSetName
    externalId
    budgetBefore
    budgetAfter
    spend
    results
    costPerResult
`

/** What the Ads Manager panel needs of one ad campaign's budget optimizer. */
export const BUDGET_OPTIMIZER_FIELDS = gql`
    fragment BudgetOptimizerFields on BudgetOptimizer {
        adCampaignId
        isOwner
        available
        automatedAvailable
        halted
        mode
        effectiveMode
        effectiveModeReason
        lastEvaluatedAt
        lastOutcome
        lastReasons
        tooMuchData
        decision {
            id
            kind
            status
            mode
            decidedAt
            expiresAt
            appliedAt
            revertsDecisionId
            amount
            currency
            ratio
            donor {
                ${SIDE_FIELDS}
            }
            receiver {
                ${SIDE_FIELDS}
            }
            reasons
            lastReason
            changes {
                seq
                role
                adSetId
                adSetName
                status
                budgetBefore
                budgetAfter
                attempts
                lastAttemptAt
            }
            actions
        }
    }
`

export const BUDGET_OPTIMIZER = gql`
    query BudgetOptimizer($adCampaignId: ID!) {
        AdCampaign {
            budgetOptimizer(adCampaignId: $adCampaignId) {
                ...BudgetOptimizerFields
            }
        }
    }
    ${BUDGET_OPTIMIZER_FIELDS}
`

const RESULT_FIELDS = `
    ok
    reason
    message
    retryable
    optimizer {
        ...BudgetOptimizerFields
    }
`

export const SET_BUDGET_OPTIMIZER_MODE = gql`
    mutation SetBudgetOptimizerMode($adCampaignId: ID!, $mode: BudgetOptimizerMode!) {
        setBudgetOptimizerMode(adCampaignId: $adCampaignId, mode: $mode) {
            ${RESULT_FIELDS}
        }
    }
    ${BUDGET_OPTIMIZER_FIELDS}
`

export const CONFIRM_BUDGET_DECISION = gql`
    mutation ConfirmBudgetDecision($adCampaignId: ID!, $decisionId: ID!) {
        confirmBudgetDecision(adCampaignId: $adCampaignId, decisionId: $decisionId) {
            ${RESULT_FIELDS}
        }
    }
    ${BUDGET_OPTIMIZER_FIELDS}
`

export const DISMISS_BUDGET_DECISION = gql`
    mutation DismissBudgetDecision($adCampaignId: ID!, $decisionId: ID!) {
        dismissBudgetDecision(adCampaignId: $adCampaignId, decisionId: $decisionId) {
            ${RESULT_FIELDS}
        }
    }
    ${BUDGET_OPTIMIZER_FIELDS}
`

export const UNDO_BUDGET_DECISION = gql`
    mutation UndoBudgetDecision($adCampaignId: ID!, $decisionId: ID!) {
        undoBudgetDecision(adCampaignId: $adCampaignId, decisionId: $decisionId) {
            ${RESULT_FIELDS}
        }
    }
    ${BUDGET_OPTIMIZER_FIELDS}
`

export const RESOLVE_PARTIAL_BUDGET_DECISION = gql`
    mutation ResolvePartialBudgetDecision($adCampaignId: ID!, $decisionId: ID!, $action: BudgetPartialAction!) {
        resolvePartialBudgetDecision(adCampaignId: $adCampaignId, decisionId: $decisionId, action: $action) {
            ${RESULT_FIELDS}
        }
    }
    ${BUDGET_OPTIMIZER_FIELDS}
`

export const RECHECK_BUDGET_DECISION = gql`
    mutation RecheckBudgetDecision($adCampaignId: ID!, $decisionId: ID!) {
        recheckBudgetDecision(adCampaignId: $adCampaignId, decisionId: $decisionId) {
            ${RESULT_FIELDS}
        }
    }
    ${BUDGET_OPTIMIZER_FIELDS}
`
